import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';
/**
 * Represents a component that is used to visualize the view when there are no
 * results.
 */
export const SearchResultsEmpty = () => (_jsx(FlexBox, Object.assign({ flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%" }, { children: _jsx(EmptyState, { title: "No results found for this search", description: "Please try another search term, check for typos, or adjust your filters." }) })));
